<template>
  <v-card
    rounded="lg"
    flat
    color="#eeeeee"
    class="card"
    width="100%"
    data-aos="fade-left"
  >
    <v-card-title class="text-wrap font-weight-bold pa-0">{{ title }}</v-card-title>

    <v-rating
      background-color="orange lighten-3"
      color="yellow darken-2"
      readonly
      :length="ratings"
      :value="ratings"
    ></v-rating>

    <p :class="[{ 'line-clamp-3': clamp }, 'description']">{{ description }}</p>

    <h4>- {{ name }}</h4>

    <!-- see more button will only be shown if words count is more than maximum words -->
    <div v-if="words > max">
      <div class="text-right">
        <span class="text-hover primary--text" @click="toggle = !toggle">
          <v-icon color="#40ecb8">mdi-chevron-right</v-icon>
          See more
        </span>
      </div>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'TestimonialCard',

    props: {
      title: { type: String, default: '' },
      description: { type: String, default: '' },
      ratings: { type: Number },
      name: { type: String, default: '' }
    },

    watch: {
      toggle(val) {
        this.clamp = val
      }
    },

    data() {
      return {
        toggle: true,
        clamp: false,
        words: 0,
        max: 30 // calculated lines per card: 3
      }
    },

    mounted() {
      this.clampText()
    },

    methods: {
      // Tried alternative methods to truncate/clamp text with dynamic
      // see more button but I ended up with this temporary method/hack...
      // Needs to be altered as this method is  not accurate enough.
      //    Trial 1: HTML DOM
      //    Trial 2: $refs
      //    Trial 3: jQuery

      /**
       * Returns boolean value
       * TRUE - text exceeded max length
       * FALSE - text is lesser than max length
       */
      clampText() {
        let wordList = this.description.split(' ');

        let minimumWordLength = 3;
        let wordLength = 0;

        wordList.forEach(element => {
          if (element.length >= minimumWordLength) {
            wordLength++
          }
        });

        this.words = wordLength;
        if (wordLength > this.max) {
          this.clamp = true
        }

        // console.log('Words: ', this.words)
        // console.log('Description: ', this.description)
        // console.log('Clamp: ', this.clamp)
        // console.log('Toggle: ', this.toggle)
      }
    }
  }
</script>

<style lang="scss" scoped>
.card {
  color: black;
  padding: 20px;

  .description {
    font-size: 14px;
    text-align: justify;
  }
}
</style>
